import { TieupResponse } from "../../api/shared/models/TieupResponse"
import { RequestedTieup } from "./RequestedTieup"

export const adaptRequestedTieup = (res: TieupResponse): RequestedTieup => {
  return new RequestedTieup({
    status: res.status,
    id: res.id,
    userId: res.user_id,
    appliedUserId: res.applied_user_id,
    hasBaseNovel: !!res.base_novel,
    baseNovelTitle: res.base_novel?.title || "",
    novelId: res.base_novel?.id || null,
    hasIllustration: !!res.illustration,
    illustrationTitle: res.illustration?.title || "",
    illustrationUrl: res.illustration?.url || "",
    createdAt: res.created_at,
    chatId: res.chat_id,
    appliedUser: res.applied_user,
    user: res.user,
    userRole: res.user_role,
    appliedUserRole: res.applied_user_role,
    wantToEliminatedByUser: res.want_to_eliminate_by_user,
    wantToEliminatedByAppliedUser: res.want_to_eliminate_by_user,
    message: res.message,
  })
}
